<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> {{ $class() }} </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'id'" [label]="'ID'" [validate]="$isValidExternalId()"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>

<cm-inspector-section>
    <ng-container cm-title> Default </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'default'" [label]="'Value'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>

<cm-inspector-section>
    <ng-container cm-title> Meta Data </ng-container>
    <ng-container cm-content>
        <cm-meta-data-list [node]="$node()"></cm-meta-data-list>
    </ng-container>
</cm-inspector-section>
